import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { createSelector } from 'reselect';
import ShoppingListIdsSelector from 'selectors/loves/shoppingListIds/shoppingListIdsSelector';
import basketSelector from 'selectors/basket/basketSelector';
import LoveActions from 'actions/LoveActions';
import { supplementAltTextWithProduct } from 'utils/Accessibility';
import Empty from 'constants/empty';
import ProductActions from 'actions/ProductActions';

const { wrapHOC } = FrameworkUtils;
const { shoppingListIdsSelector } = ShoppingListIdsSelector;

const fields = createSelector(
    (_state, ownProps) => ownProps.sku,
    (_state, ownProps) => ownProps.imageProps,
    shoppingListIdsSelector,
    basketSelector,
    (sku, imageProperties, shoppingListIds, basket) => {
        let imageProps = Empty.Object;

        if (!imageProperties) {
            imageProps = {
                altText: supplementAltTextWithProduct(sku),
                disableLazLoad: true,
                id: sku.skuId,
                skuImages: sku.skuImages || []
            };
        } else {
            imageProps = imageProperties;
        }

        return {
            shoppingListIds,
            basket,
            imageProps
        };
    }
);

const functions = {
    showMyListsModal: LoveActions.showMyListsModal,
    setSkuLoveData: LoveActions.setSkuLoveData,
    setSkuLoveImageData: LoveActions.setSkuLoveImageData,
    updateSkuInCurrentProduct: ProductActions.updateSkuInCurrentProduct,
    setCurrentProduct: LoveActions.setCurrentProduct
};

const withProductLoveProps = wrapHOC(connect(fields, functions));

export {
    withProductLoveProps, fields, functions
};
